import { render, staticRenderFns } from "./PlacesDynamicTopMatter.vue?vue&type=template&id=229f9ddc&scoped=true"
import script from "./PlacesDynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./PlacesDynamicTopMatter.vue?vue&type=script&lang=ts"
import style0 from "./PlacesDynamicTopMatter.vue?vue&type=style&index=0&id=229f9ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229f9ddc",
  null
  
)

export default component.exports